import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { useId, useRef, type FC } from "react";

export const CursorLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23 7.12956V16.8705C23 17.663 22.5713 18.3939 21.8786 18.7825L13.0786 23.7183C12.4089 24.0939 11.5912 24.0939 10.9215 23.7183L2.12143 18.7825C1.42869 18.3939 1 17.663 1 16.8705V7.12956C1 6.33703 1.42869 5.60612 2.12143 5.21759L10.9215 0.281724C11.5912 -0.0939107 12.4089 -0.0939106 13.0786 0.281739L21.8786 5.21759C22.5713 5.60612 23 6.33703 23 7.12956Z"
                fill="#F6F6F6"
                stroke="#191A1A"
            />
            <path
                d="M12 22.9091L21.9 17.4546L12 12L2.1 17.4546L12 22.9091Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path d="M21.9 17.4546V6.54546L12 1.09094V12L21.9 17.4546Z" fill={`url(#paint1_linear_${id})`} />
            <path d="M12 1.09094L2.1 6.54546V17.4546L12 12V1.09094Z" fill={`url(#paint2_linear_${id})`} />
            <path d="M21.9 6.54541L12 22.909V11.9999L21.9 6.54541Z" fill="#555555" />
            <path d="M21.9 6.54541L12 12L2.1 6.54541H21.9Z" fill="black" />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="12"
                    y1="12"
                    x2="12"
                    y2="22.9091"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.16" stopOpacity="0.39" />
                    <stop offset="0.658" stopOpacity="0.8" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="21.9"
                    y1="6.5791"
                    x2="12.2258"
                    y2="12.505"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.182" stopOpacity="0.31" />
                    <stop offset="0.715" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="12"
                    y1="1.09094"
                    x2="2.73291"
                    y2="17.8055"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopOpacity="0.6" />
                    <stop offset="0.667" stopOpacity="0.22" />
                </linearGradient>
            </defs>
        </svg>
    );
};
